import instance from 'utils/axios/instance.axios';
import { RESEARCH_KPI_GROUPS } from './_constant';

export const getAll = (params) =>
  instance.get(RESEARCH_KPI_GROUPS.GET_ALL, {
    params,
  });

export const create = (data = {}) => instance.post(RESEARCH_KPI_GROUPS.CREATE, data);

export const update = ({ id, data }) => instance.patch(RESEARCH_KPI_GROUPS.UPDATE(id), data);

export const deleteById = (id) => instance.delete(RESEARCH_KPI_GROUPS.DELETE(id));

export const restore = (id) => instance.patch(RESEARCH_KPI_GROUPS.RESTORE(id));

export const getAppliedYears = () => instance.get(RESEARCH_KPI_GROUPS.GET_APPLIED_YEARS);

export const clone = (data = {}) => instance.post(RESEARCH_KPI_GROUPS.CLONE, data);
